<template>
  <dl class="box-faq-tabs">
    <div v-for="item in content" :key="item.id" :class="{ active : active_el == item.id }">
      <dt class="faq-title">
        {{ item.title }}
        <a class="icon btn-accordion btn-open-accordion" href="#" @click.prevent="activate(item.id)">
          <img src="/static/svg/icons_clarity-plus.svg">
        </a>
        <a class="icon btn-accordion btn-close-accordion" href="#" @click.prevent="activate('')"><img src="/static/svg/icons_clarity-minus.svg">
        </a>
      </dt>
      <dd class="faq-text" v-if="active_el == item.id" v-html="item.text"></dd>
    </div>
  </dl>
</template>

<script>

export default {
  name: 'Tabs',
  data () {
    return {
      active_el: 0
    }
  },
  props: ['content'],
  methods: {
    activate: function (el) {
      this.active_el = el
    }
  }
}

</script>

<style>

.faq-text a:hover {
  color: #ffbf2a;
}

.faq-text li {
  font-size: 1.1em;
}

.faq-text p:last-child {
  margin-bottom: 0;
}

</style>

<style lang="scss" scoped>

.box-faq-tabs {
  border: 1px solid $white;
  border-radius: 3px;

  > div:first-of-type .faq-title {
    border-top: 0;
  }
}

.faq-title {
  position: relative;
  padding: 1.5rem 3rem 1.5rem 1.5rem;
  margin-bottom: 0;
  border-top: 1px solid $white;
  transition: .3s;

  .btn-accordion {
    display: block;
    position: absolute;
    right: 1%;
    top: 30%;
    width: 24px;
    height: 24px;
  }
  .btn-close-accordion {
    display: none;
    top: 30%;
  }
}

.active {

  .faq-title {
    background-color: $green;
    color: $white;
    box-shadow: 0 4px 5px rgba(0, 0, 0, .5);
  }

  .btn-open-accordion {
    display: none;
  }

  .btn-close-accordion {
    display: block;
  }
}

.faq-text {
  margin: 0;
  padding: 1.5rem;
  font-size: .9em;
  overflow: hidden;
}

</style>



// WEBPACK FOOTER //
// src/components/Tabs.vue